import { initSwiper } from '../../../../blocks/_common/swiper-init';

document.addEventListener( 'DOMContentLoaded', () => {
    const carousels = document.querySelectorAll( '.crsc-carousel' );
    carousels.forEach( ( carousel ) => {
        initSwiper( carousel as HTMLElement );
    } );
} );
